import Dropzone from 'react-dropzone';
import React, { Component } from 'react';
import * as Colors from 'material-ui/styles/colors';
import RaisedButton from 'material-ui/RaisedButton';
import {TweenMax} from 'gsap';
import Dimensions from 'react-dimensions';

/* global Strong Linear SlowMo Ease TimelineMax */

class ImagesDropzone extends Component {
  state = {}

  shouldComponentUpdate(nextProps, nextState) {
    return this.state.dragInProgress !== nextState.dragInProgress;
  }

  componentDidUpdate() {
    const DURATION = 0.22;
    if (this.state.dragInProgress) {
      TweenMax.to('.stroke-overlap-forward', DURATION, {
        strokeDashoffset: 10,
        stroke: Colors.lightGreen700,
      });
      TweenMax.to('.stroke-overlap-backward', DURATION, {
        strokeDashoffset: -10,
        stroke: Colors.lightGreen700,
      });
      TweenMax.to('.stroke-animate-fill', DURATION, {
        fill: Colors.lightGreen100,
        stroke: Colors.lightGreen700,
      });
    } else {
      TweenMax.to('.stroke-overlap', DURATION, {
        strokeDashoffset: 0,
        stroke: Colors.grey400,
      });
      TweenMax.to('.stroke-animate-fill', DURATION, {
        fill: Colors.grey200,
      });
    }
  }

  open() {
    this.refs.dropzone.open();
  }

  render() {
    const {containerHeight, containerWidth} = this.props;
    if (!(containerHeight > 0 && containerWidth > 0)) {
      return null;
    }
    const STROKE_WIDTH = 4;
    return (<Dropzone
      onDrop={(files) => { this.props.onDrop(files); this.setState({dragInProgress: false});}}
      accept="image/jpeg,image/pjpeg,image/png"
      style=
        {{
          width: containerWidth,
          height: containerHeight,
          position: 'relative',
          margin: 'auto',
          ...this.props.style
        }}
      ref="dropzone"
      multiple={this.props.multiple}
      onDragEnter={() => {this.setState({dragInProgress: true});}}
      onDragLeave={() => {this.setState({dragInProgress: false});}}
      disablePreview
    >
      <div
        style={{
          width: '100%',
          height: '100%',
          display: 'table',
          position: 'absolute',
          zIndex: 1
        }}
      >
        <div style={{
          display: 'table-cell',
          textAlign: 'center',
          verticalAlign: 'middle',
          position: 'relative',
          top: -3
        }}>
          <div style={{fontSize: 16, marginBottom: 5}}>{this.props.messageText}</div>
          <div style={{fontSize: 14, margin: 10}}>or</div>
          <RaisedButton label={this.props.buttonText || 'no label'}/>
        </div>
      </div>
      <svg
        style={{
          position: 'absolute'
        }}
        height={containerHeight}
        width={containerWidth} >
          <rect strokeWidth={STROKE_WIDTH}
                stroke={Colors.grey400}
                x="2"
                y="2"
                rx="15"
                width= {containerWidth - STROKE_WIDTH }
                height={ containerHeight - STROKE_WIDTH }
                strokeLinecap="round"
                fill={Colors.grey200}
                className = "stroke-animate stroke-animate-stroke stroke-animate-fill"
                strokeDasharray="10,20"
          />
        <rect strokeWidth={STROKE_WIDTH}
              stroke={Colors.grey400}
              x="2"
              y="2"
              rx="15"
              width= {containerWidth - STROKE_WIDTH }
              height={ containerHeight - STROKE_WIDTH }
              strokeLinecap="round"
              fill="none"
              className = "stroke-overlap stroke-overlap-forward stroke-animate-stroke"
              strokeDasharray="10,20"
        />
        <rect strokeWidth={STROKE_WIDTH}
              stroke={Colors.grey400}
              x="2"
              y="2"
              rx="15"
              width= {containerWidth - STROKE_WIDTH }
              height={ containerHeight - STROKE_WIDTH }
              strokeLinecap="round"
              fill="none"
              className = "stroke-overlap stroke-overlap-backward stroke-animate-stroke"
              strokeDasharray="10,20"
        />
      </svg>
    </Dropzone>);
  }
}

ImagesDropzone.defaultProps = {
  multiple: true
};

export default Dimensions()(ImagesDropzone);
